import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "region-dashboards-representative-abroad-info" }
const _hoisted_2 = { class: "region-dashboards-representative-abroad-info__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionDashboardsRepresentativeAbroadBaseInfo = _resolveComponent("RegionDashboardsRepresentativeAbroadBaseInfo")!
  const _component_RegionDashboardsRepresentativeAbroadInfoTable = _resolveComponent("RegionDashboardsRepresentativeAbroadInfoTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RegionDashboardsRepresentativeAbroadBaseInfo, { filter: _ctx.filter }, null, 8, ["filter"]),
      _createVNode(_component_RegionDashboardsRepresentativeAbroadInfoTable, { filter: _ctx.filter }, null, 8, ["filter"])
    ])
  ]))
}